import { render, staticRenderFns } from "./homePart2.vue?vue&type=template&id=27872f0c&scoped=true&"
import script from "./homePart2.vue?vue&type=script&lang=js&"
export * from "./homePart2.vue?vue&type=script&lang=js&"
import style0 from "./homePart2.vue?vue&type=style&index=0&id=27872f0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27872f0c",
  null
  
)

export default component.exports